<div class="core-ui-loader-base" [class.core-ui-loader-base--no-padding]="!withPadding" [style.gap.px]="gapPx">
    <div class="klab-loader" [style.width.px]="sizePx" [style.height.px]="sizePx" [style.--dot-size.px]="dotSizePx"
        [style.--dot-left.%]="dotLeftPercent" [style.--dot-rotate.deg]="dotRotateDeg"
        [style.--dot-translate.px]="dotTranslatePx" aria-hidden="true">
        <div class="klab-loader-dot"></div>
    </div>
</div>